/**
 * The parts a workspace's card renderer is made of, so UMED, Scheduling and
 * Finance cards read as one family. All phrasing content: a card's body is the
 * button that opens it, so nothing here is a control.
 */
import React from 'react';
import { StatusBar } from '../cells';
import FilledStatusChip from '../../status/FilledStatusChip';
import type { KanbanChip } from './types';

/** At most two chips (the server chooses and orders them); the tone is a word too, for a screen reader. */
export function CardChips({ chips }: { chips: KanbanChip[] }) {
  const shown = chips.slice(0, 2);
  if (!shown.length) return null;
  return (
    <span className="okb-chips">
      {shown.map((c) => (
        <span key={c.key} className={`okb-chip okb-chip--${c.tone}`} data-chip={c.key}>
          {c.tone === 'stop' && <span className="okb-sr">Blocking: </span>}
          {c.label}
        </span>
      ))}
    </span>
  );
}

/**
 * The record's status word FILLED with its learned colour, small (the same chip the table draws), then an optional
 * quiet qualifier. A word with no colour, or no word, is the board kit's StatusBar: hatched, and said in words.
 */
export function CardStatus({ word, color, emptyLabel, after }: { word: string | null | undefined; color: string | null | undefined; emptyLabel?: string; after?: React.ReactNode }) {
  return (
    <span className="okb-status">
      {word && color ? <FilledStatusChip word={word} hex={color} size="sm" /> : <StatusBar word={word} color={color} emptyLabel={emptyLabel} />}
      {after ? <span className="okb-status__after">{after}</span> : null}
    </span>
  );
}
